<template>
  <div id="cartPopup" :class="showCart !== null ? (showCart ? 'animated bounceInRight' : 'animated bounceOutRight') : ''">
    <div class="close" @click="closeCartPopup">×</div>
    <div class="content">
      <div class="ornaments">
        <img src="../assets/img/lamps-right.png" class="lamps-right" align="Lamps ornaments" />
      </div>
      <h3>Your Cart</h3>

      <div class="cart">
        <div class="products">
          <div v-for="(row, index) in cart" class="product" v-if="showFullList ? true : (index < 4)">
            <div class="image">
              <img :src="row.image" v-if="row.image && row.image !== ''" :alt="row.title" />
              <img src="../assets/img/food.png" v-else :alt="row.title" />
            </div>
            <div class="details">
              <div class="title">{{ row.title }}</div>
              <div class="quantity">
                <div class="pull-left">x {{ row.quantity }}</div>
                <div class="pull-right">£{{ (row.discount > 0 ? row.discount : row.price).toFixed(2) }}</div>
              </div>
            </div>
            <div class="delete" @click="deleteProductFromCart(index)">
              <i class="fa fa-trash"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <a v-if="!showFullList && cart.length > 4" @click="showFullList = true">View {{ cart.length - 4 }} product{{ cart.length > 5 ? 's' : '' }} more</a>
      </div>

      <div class="totals">
        <div class="pull-left">
          <strong>Subtotal</strong>
        </div>
        <div class="pull-right">
          <strong>£{{ getCartTotal.toFixed(2) }}</strong>
        </div>
      </div>

      <div class="btns text-center">
        <div @click="goToCheckout">
          <b-button class="btn-default btn-fill full-width">Checkout</b-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Notification from 'src/components/UIComponents/NotificationPlugin/Notification.vue'
  import env from '../env.json'

  let kf

  export default {
    name: 'cart-popup',
    props: ['showCart'],
    computed: {
      ...mapState({
        cart: state => state.cart
      }),
      ...mapGetters([
        'getCartTotal'
      ])
    },
    mounted () {
      kf = this
    },
    data () {
      return {
        base_url: env.base_url,
        showFullList: false
      }
    },
    methods: {
      closeCartPopup: () => {
        kf.showCart = false
        kf.$emit('closeShowCart')
      },
      deleteProductFromCart: (key) => {
        if (confirm('Are you sure you want to remove this product from the cart?')) {
          kf.cart.splice(key, 1)
          kf.$store.dispatch('UpdateCart', kf.cart)
        }
      },
      goToCheckout: () => {
        kf.closeCartPopup()
        kf.$router.push({ name: 'checkout' })
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    },
    components: {
      Notification
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// cart-popup.vue?957a8da4